import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

type PriceViewModel = {
	onSale: boolean;
	priceAsCurrency: String;
	priceAsFloat: number;
	saleAsCurrency: String;
	saleAsFloat: number;
};

type Props = {
	price: PriceViewModel;
	loading?: boolean;
	splitpay?: boolean;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'PriceObject',
  props: {
    price: {},
    loading: { type: Boolean },
    splitpay: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ccf-price", {
			'ccf-price--loading': props.loading,
		}])
  }, [
    _createElementVNode("span", {
      class: _normalizeClass({
				'ccf-price--crossed': props.price.onSale,
				'ccf-price-splitpay-tag': !props.price.onSale && props.splitpay,
				'ccf-price--sale': !props.price.priceAsCurrency,
			})
    }, _toDisplayString(!props.loading && props.price.priceAsCurrency
					? props.price.priceAsCurrency
					: "🎁 " + _ctx.translations["Free"]), 3),
    (props.price.onSale)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(["ccf-price--sale", {
				'ccf-price-splitpay-tag': props.price.onSale && props.splitpay,
			}])
        }, _toDisplayString(props.price.saleAsCurrency), 3))
      : _createCommentVNode("", true)
  ], 2))
}
}

})